// client/src/routes/app/reports/index.tsx — SCR-REPT-001 „Galerie rapoarte" · REPORT-003
// (04 §8.14).
//
// Replaces UI-003's `PlaceholderScreen`, which named this item as its owner.
//
// `Reports.Read` is UI-003's guard and stays: the sidebar hides the entry, and this renders
// SCR-SYS-403 for the URL that was typed anyway (§9.2.2). The two FISCAL reports in the gallery
// need `Fiscal.Read` on their own payload routes and the gallery says so on their cards rather
// than removing them — the catalogue endpoint refuses to narrow itself by permission and the
// screen follows it (D-1473).

import { createFileRoute } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { ReportGallery } from '@/features/reports/ReportGallery';

export const Route = createFileRoute('/app/reports/')({
  component: ReportsGalleryRoute,
});

function ReportsGalleryRoute() {
  return (
    <RequirePermission permission="Reports.Read">
      <ReportGallery />
    </RequirePermission>
  );
}
